import React from "react";
import {
  Box,
  Divider,
  Heading,
  IconButton,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  SimpleGrid,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tooltip,
  Tr,
  useDisclosure,
} from "@chakra-ui/react";
import { AiFillEye } from "react-icons/ai";

export default function ViewCOCDeleteRequestModal({ data }) {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const testTypes = [
    { label: "Validation Analysis Order", value: "validation-analysis-order" },
    {
      label: "Laboratory Composite Order",
      value: "laboratory-composite-order",
    },
    { label: "Detailed Analysis Order", value: "detailed-analysis-order" },
  ];
  var blankCount = 0;

  const formatDate = (value, monthForm) => {
    value = value.split("/").reverse().join("-");
    value = new Date(value);
    return (
      value.getDate() +
      "-" +
      value.toLocaleString("en-us", { month: monthForm }) +
      "-" +
      value.getFullYear()
    );
  };

  return (
    <>
      <Tooltip label="View Request">
        <IconButton
          onClick={onOpen}
          bgColor="primary.100"
          color="primary.main"
          fontSize="xl"
          icon={<AiFillEye />}
          isRound
        />
      </Tooltip>
      <Modal
        isOpen={isOpen}
        onClose={onClose}
        size="xl"
        scrollBehavior="inside"
        isCentered
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Deletion Request Order Details</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            {data.status === "pending" ? (
              <>
                <Box>
                  <Heading as="h6" fontSize="sm">
                    Comment
                  </Heading>
                  <Text
                    mb="3"
                    pb="3"
                    borderBottom="1px"
                    borderColor="primary.main"
                  >
                    {data.comment}
                  </Text>
                  <SimpleGrid columns={2} spacing={3} mb="3">
                    <Box>
                      <Heading as="h6" fontSize="sm">
                        Company Name
                      </Heading>
                      <Text>
                        {data.coc.clientName !== ""
                          ? data.coc.clientName
                          : "N/A"}
                      </Text>
                    </Box>
                    <Box>
                      <Heading as="h6" fontSize="sm">
                        Contact Name
                      </Heading>
                      <Text>{data.coc.contactName}</Text>
                    </Box>
                  </SimpleGrid>
                  <SimpleGrid columns={2} spacing={3} mb="3">
                    <Box>
                      <Heading as="h6" fontSize="sm">
                        Client Email
                      </Heading>
                      <Text>{data.coc.email}</Text>
                    </Box>
                    <Box>
                      <Heading as="h6" fontSize="sm">
                        Phone
                      </Heading>
                      <Text>
                        {data.coc.phone !== "" ? data.coc.phone : "N/A"}
                      </Text>
                    </Box>
                  </SimpleGrid>
                </Box>
                <Divider borderColor="primary.main" my="3" />
                <Box>
                  <SimpleGrid columns={2} spacing={3} mb="3">
                    <Box>
                      <Heading as="h6" fontSize="sm">
                        Date Sampled
                      </Heading>
                      <Text>{data.coc.dateSampled}</Text>
                    </Box>
                    <Box>
                      <Heading as="h6" fontSize="sm">
                        Order Type
                      </Heading>
                      <Text>
                        {
                          testTypes.find(
                            (opt) => opt.value === data.coc.samplingFor
                          ).label
                        }
                      </Text>
                    </Box>
                  </SimpleGrid>
                  <SimpleGrid columns={2} spacing={3} mb="3">
                    <Box>
                      <Heading as="h6" fontSize="sm">
                        {data.coc.propertyType !== "vehicle"
                          ? "Property Address"
                          : "Vehicle Details"}
                      </Heading>
                      <Text>
                        {data.coc.propertyType !== "vehicle"
                          ? data.coc.address +
                            ", " +
                            data.coc.city +
                            ", " +
                            data.coc.state +
                            ", " +
                            data.coc.postcode
                          : data.coc.VIN +
                            ", " +
                            data.coc.rego +
                            ", " +
                            data.coc.regoState}
                      </Text>
                    </Box>
                    <Box>
                      <Heading as="h6" fontSize="sm">
                        Sampling Technique
                      </Heading>
                      <Text>
                        {data.coc.samplingTechnique !== ""
                          ? data.coc.samplingTechnique
                          : "N/A"}
                      </Text>
                    </Box>
                    <Box>
                      <Heading as="h6" fontSize="sm">
                        Security Seal No.
                      </Heading>
                      <Text>
                        {data.coc.securitySealNo !== ""
                          ? data.coc.securitySealNo
                          : "N/A"}
                      </Text>
                    </Box>
                    <Box>
                      <Heading as="h6" fontSize="sm" textTransform="capitalize">
                        Testing Location
                      </Heading>
                      <Text textTransform="capitalize">
                        {data.coc.propertyType ? data.coc.propertyType : "N/A"}
                      </Text>
                    </Box>
                    {data.identifier && (
                      <Box>
                        <Heading as="h6" fontSize="sm">
                          Lab Sample Identifier
                        </Heading>
                        <Text>
                          {formatDate(data.coc.dateCreated, "long").replaceAll(
                            "-",
                            ""
                          ) +
                            "-" +
                            data.coc.identifierName +
                            "-" +
                            data.coc.identifier}
                        </Text>
                      </Box>
                    )}
                  </SimpleGrid>
                </Box>
                <Divider borderColor="primary.main" my="3" />
                <Heading as="h6" fontSize="sm" mb="3">
                  Samples
                </Heading>
                <TableContainer>
                  <Table variant="striped" borderWidth="1px" mb="2">
                    <Thead>
                      <Tr>
                        <Th textAlign="center">Sample ID</Th>
                        <Th textAlign="center">Sampling Location</Th>
                      </Tr>
                    </Thead>
                    <Tbody>
                      {data.coc.samples.map((item, i) => {
                        if ((i + 1) % 20 === 1) {
                          blankCount++;
                          return (
                            <>
                              <Tr>
                                <Td py="2" textAlign="center">
                                  {"FB" + blankCount}
                                </Td>
                                <Td py="2" textAlign="center">
                                  Field Blank
                                </Td>
                              </Tr>
                              <Tr>
                                <Td py="2" textAlign="center">
                                  {i + 1}
                                </Td>
                                <Td py="2" textAlign="center">
                                  {item.value}
                                </Td>
                              </Tr>
                            </>
                          );
                        } else {
                          return (
                            <Tr>
                              <Td py="2" textAlign="center">
                                {i + 1}
                              </Td>
                              <Td py="2" textAlign="center">
                                {item.value}
                              </Td>
                            </Tr>
                          );
                        }
                      })}
                    </Tbody>
                  </Table>
                </TableContainer>
              </>
            ) : (
              <>
                <Heading as="h6" fontSize="sm">
                  Comment
                </Heading>
                <Text>{data.comment}</Text>
              </>
            )}
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
}
